import { booleanAttribute, Component, computed, input } from '@angular/core';
import type { RiskTone } from '../../../core/models/types';
import { UwIcon } from '../icon/uw-icon';

@Component({
  selector: 'uw-badge',
  standalone: true,
  template: `
    <span [class]="classes()" [attr.data-tone]="tone()">
      @if (icon()) {
        <uw-icon [name]="icon()" [size]="11" />
      }
      <ng-content />
    </span>
  `,
  imports: [UwIcon],
})
export class UwBadge {
  readonly tone = input<RiskTone | 'ai' | 'accent'>('neutral');
  readonly icon = input<string>('');
  readonly subtle = input(false, { transform: booleanAttribute });

  protected readonly classes = computed(() => {
    const base = 'inline-flex items-center gap-1 font-semibold whitespace-nowrap';
    const sizes = this.subtle()
      ? 'text-[10px] px-1.5 py-px rounded'
      : 'text-[11px] px-2 py-0.5 rounded-full';
    const tones: Record<string, string> = {
      success: 'bg-success-soft text-success',
      warning: 'bg-warning-soft text-warning',
      danger: 'bg-danger-soft text-danger',
      info: 'bg-info-soft text-info',
      neutral: 'bg-surface-sunken text-secondary border border-line',
      ai: 'bg-ai-soft text-ai',
      accent: 'bg-accent-soft text-accent',
    };
    return `${base} ${sizes} ${tones[this.tone()] ?? tones['neutral']}`;
  });
}
